import { useMediaQuery } from "@mui/material";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import TableViewv2 from "./TableViewv2";
import CardViewv2 from "./CardViewv2";
import { GridLoader } from "react-spinners";
import Header from "./Header/Header";
import Loading from "../Loading";
import TableSkeleton from "./TableSkeleton";

const TableCardv2 = ({
  header,
  debounce,
  complementaryHeaderTop,
  complementaryHeaderBottom,
  handleGrupoEmpresa,
  hasEmpresa,
  uniqueEmpresa,
  selectedAllEmpresas,
  columns,
  data,
  loading,
  loadingVersao,
  loadingTable,
  searchPlaceholder,
  colunaHover,
  paginationConfig,
}) => {
  const minDesktop = useMediaQuery("(max-width: 900px)");
  const [view, setView] = useState(minDesktop ? "grid" : "table");
  const safeData = Array.isArray(data) ? data : [];

  const hasBotoes = safeData.some((item) => item.hasOwnProperty("btn"));

  useEffect(() => {
    setView(minDesktop ? "grid" : "table");
  }, [minDesktop]);

  const handleChangeView = (name) => {
    setView(name);
  };

  const tableContent =
    loadingVersao ? (
      <div className={styles.containerTable}>
        <TableSkeleton
          columns={columns}
          rows={5}
          hasBotoes={hasBotoes}
        />
      </div>
    ) : (
      <div className={`${styles.containerTable} ${loadingTable ? styles.containerTableLoading : ""}`}>
        {loadingTable && (
          <div className={styles.tableOverlay} aria-hidden="true">
            <GridLoader color="#18316e" loading={true} size={8} aria-label="Carregando" />
          </div>
        )}
        {safeData.length > 0 ? (
          view === "table" ? (
            <TableViewv2
              columns={columns}
              data={safeData}
              hasBotoes={hasBotoes}
              colunaHover={colunaHover}
              paginationConfig={paginationConfig}
            />
          ) : (
            <CardViewv2
              columns={columns}
              data={safeData}
              hasBotoes={hasBotoes}
              paginationConfig={paginationConfig}
            />
          )
        ) : (
          <h3 className={styles.noData}>
            <GridLoader
              color="#18316e"
              loading={true}
              size={5}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            Nenhum item encontrado!
          </h3>
        )}
      </div>
    );

  return (
    <div className={styles.container}>
      <div className={styles.paper}>
        <Header
          header={header}
          debounce={debounce}
          hasEmpresa={hasEmpresa}
          handleGrupoEmpresa={handleGrupoEmpresa}
          complementaryHeaderTop={complementaryHeaderTop}
          complementaryHeaderBottom={complementaryHeaderBottom}
          selectedAllEmpresas={selectedAllEmpresas}
          uniqueEmpresa={uniqueEmpresa}
          view={view}
          handleChangeView={handleChangeView}
          searchPlaceholder={searchPlaceholder}
        />
        {loading ? (
          <Loading loading={loading} />
        ) : (
          tableContent
        )}
      </div>
    </div>
  );
};

export default TableCardv2;

//
//#region Documentação

//----COPIE E COLE TUDO ABAIXO ALTERANDO APENAS O NOME "ExemploTableCard"-----

// import TableCardv2 from "../../components/TableCardv2";
// import AccessibleForwardIcon from "@mui/icons-material/AccessibleForward";
// import { Rating } from "@mui/material";
// import { debounce } from "lodash";

// const ExemploTableCard = () => {

//   const header = {
//     icon: <AccessibleForwardIcon />,
//     title: "Teste",
//   };
//   const handleDebounce = (value) => {
//     console.log(value);
//   };

//   const functionDebounce = debounce((value) => handleDebounce(value), 1000)
//   const Complemento = () => {
//     return (
//       <>
//         <div>
//           <h1>Teste</h1>
//           <h2>Complemento</h2>
//           <button>Testando complemento</button>
//         </div>
//         <Rating name="half-rating" defaultValue={2.5} precision={0.5} />
//       </>
//     );
//   };

//   const columns = [
//     { key: "name", label: "Nome" },
//     { key: "age", label: "Idade" },
//     { key: "valor", label: "Valor" },
//     { key: "imposto", label: "Imposto" },
//     { key: "dt", label: "Data" },
//     { key: "teste", label: "Testando Ações" },
//     { key: "actions", label: "Teste" },
//   ];

//   const data = [
//     {
//       name: "Felipe",
//       dt: "14/04/2025",
//       valor: "R$ 27,00",
//       age: 26,
//       imposto: "30%",
//       actions: () => <button>Editar</button>,
//       teste: () => <input type="text" placeholder="Digite algo" />,
//       btn: [
//         {
//           icon: <AccessibleForwardIcon />,
//           title: "Teste",
//           onClick: () => handleDebounce(),
//         },
//       ],
//     },
//     {
//       name: "Paulo",
//       age: 27,
//       valor: "R$ 72,00",
//       dt: "14/04/2023",
//       imposto: "46%",
//       teste: () => (
//         <Rating name="half-rating" defaultValue={2.5} precision={0.5} />
//       ),
//       actions: () => <button>Editar</button>,
//       btn: [
//         {
//           icon: <AccessibleForwardIcon />,
//           title: "Teste",
//           onClick: () => handleDebounce(),
//         },
//         {
//           icon: <AccessibleForwardIcon />,
//           title: "Teste 2",
//           onClick: () => handleDebounce(),
//         },
//       ],
//     },
//   ];

//   const handleGrupoEmpresa = (value) => {
//     // exemplo de retorno de value
//     //{
//     //  GE: { id: "11", detalhes: "ACR CONSULTORIA EMPRESARIAL" },
//     //  CNPJ: [
//     //    { id: "9931", detalhes: "69262426000110" },
//     //    { id: "9934", detalhes: "41077081720823" },
//     //  ],
//     //};
//   };

//   return (
//     <div>
//       <TableCardv2
//         columns={columns}
//         data={data}
//         header={header}
//         debounce={functionDebounce}
//         complementaryHeaderTop={<Complemento />}
//         complementaryHeaderBottom={<Complemento />}
//         handleGrupoEmpresa={handleGrupoEmpresa}
//         hasEmpresa
//         uniqueEmpresa
//         selectedAllEmpresas
//       />
//     </div>
//   );
// };

// export default ExemploTableCard;

//#endregion
